"use strict";
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
;
function generic(_a) {
    var size = _a.size, _b = _a.color, color = _b === void 0 ? "currentColor" : _b;
    return React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none" },
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.7514 7.39125C16.3795 7.88406 16.9022 8.49802 17.2884 9.19669C17.6747 9.89537 17.9166 10.6645 17.9999 11.4585L15.8647 10.9275C15.6637 10.2565 15.2909 9.64969 14.783 9.16726C14.2752 8.68483 13.6501 8.34354 12.9697 8.17725C10.8202 7.6425 8.64969 8.9205 8.12094 11.0317C7.59219 13.143 8.90844 15.288 11.0587 15.8228C11.7383 15.9943 12.451 15.9856 13.1263 15.7975C13.8016 15.6095 14.4161 15.2485 14.9092 14.7502L17.0444 15.2805C16.597 15.9428 16.0214 16.5087 15.3515 16.9448C14.6816 17.3808 13.9312 17.6782 13.1444 17.8193L12.5369 20.25L10.5899 19.7663L11.0729 17.835C10.7424 17.7806 10.4169 17.6996 10.0994 17.5928L9.61719 19.524L7.67019 19.0395L8.27769 16.6088C6.49419 15.2025 5.59644 12.8617 6.17469 10.548C6.75294 8.23425 8.64744 6.58725 10.8847 6.18075L11.4922 3.75L13.4392 4.23375L12.9562 6.165C13.2867 6.21936 13.6123 6.30038 13.9297 6.40725L14.4119 4.476L16.3589 4.9605L15.7514 7.39125Z", fill: color }));
}
exports["default"] = generic;
//# sourceMappingURL=generic.js.map